import PropTypes from 'prop-types';
import { HeroSectionStyles } from '../styles';

function Hero({ company }) {
  const coverUrl = company?.coverUrl || company?.logoUrl;
  const name = company?.name || 'Company';
  const rawDesc =
    typeof company?.description === 'string' ? company.description : '';
  const taglineText = rawDesc
    ? rawDesc.replace(/<[^>]+>/g, '').trim().substring(0, 200)
    : '';

  return (
    <HeroSectionStyles id="hero">
      {coverUrl && (
        <div
          className="hero-cover"
          style={{ backgroundImage: `url(${coverUrl})` }}
          role="img"
          aria-label={name}
        />
      )}
      <div className="hero-overlay" />
      <div className="hero-content">
        {company?.logoUrl && (
          <img
            src={company.logoUrl}
            alt=""
            className="hero-logo"
            onError={(e) => {
              const img = e.target;
              if (img) img.style.display = 'none';
            }}
          />
        )}
        <h1 className="hero-title">{name}</h1>
        {taglineText && (
          <p className="hero-tagline">
            {taglineText}
            {taglineText.length >= 200 ? '...' : ''}
          </p>
        )}
      </div>
    </HeroSectionStyles>
  );
}

Hero.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    logoUrl: PropTypes.string,
    coverUrl: PropTypes.string,
  }),
};

Hero.defaultProps = {
  company: null,
};

export default Hero;
